var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigurePricing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.101562,
    width: 38,
    height: 37.8036,
    rx: 10,
    fill: "#EBE5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0911 10.0625C11.3714 9.575 11.8979 9.25 12.5 9.25H19L29.8721 20.1221C30.5083 20.7583 30.5115 21.7885 29.8786 22.4222L24.0473 28.2536C23.5321 28.7687 22.7537 28.8629 22.1387 28.5371L21.6098 29.0661C20.9776 29.6982 19.9466 29.6966 19.3096 29.0596L8.4375 18.1875V11.6875C8.4375 10.784 9.16469 10.0625 10.0625 10.0625H11.0911ZM10.8758 10.875H10.0698C9.61725 10.875 9.25081 11.2463 9.25081 11.694V17.7812L19.8946 28.4827C20.2106 28.8004 20.7217 28.7996 21.0353 28.4843L21.5082 28.0082L10.875 17.375L10.8758 10.875ZM18.5946 10.0625H12.5073C12.0548 10.0625 11.6883 10.4338 11.6883 10.8815V16.9688L22.3321 27.6702C22.6481 27.9879 23.1592 27.9871 23.4728 27.6718L29.2936 21.8121C29.608 21.4952 29.6064 20.9841 29.2887 20.6689L18.5946 10.0625ZM15.3446 15.75C14.2225 15.75 13.3133 14.8408 13.3133 13.7188C13.3133 12.5967 14.2225 11.6875 15.3446 11.6875C16.4666 11.6875 17.3758 12.5967 17.3758 13.7188C17.3758 14.8408 16.4666 15.75 15.3446 15.75ZM15.3446 14.9375C16.0173 14.9375 16.5633 14.3915 16.5633 13.7188C16.5633 13.046 16.0173 12.5 15.3446 12.5C14.6718 12.5 14.1258 13.046 14.1258 13.7188C14.1258 14.3915 14.6718 14.9375 15.3446 14.9375Z",
    fill: "#4F2AAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurePricing);
export default __webpack_public_path__ + "static/media/configure-pricing.00ea6bda51d36513fd447916b4a4041e.svg";
export { ForwardRef as ReactComponent };